import { useState } from 'react';
import { Toggle } from '@skyline-platform/alchemy';
import { useItems } from './utils/ItemsContext';
import { ActionsContent } from './utils/ActionsContent';
import PropTypes from 'prop-types';

export const ToggledSection = ({
  title,
  description,
  initialState = false,
  onConfirmAction,
}) => {
  const { streams } = useItems();
  const [toggleState, setToggleState] = useState(initialState);

  return (
    <ActionsContent
      title={title}
      description={description}
      confirmAction={() => onConfirmAction(toggleState, streams)}
      confirmBtnState={streams.length > 0 ? 'default' : 'disabled'}
    >
      <Toggle
        checked={toggleState}
        handleChange={(e) => {
          setToggleState(e.target.checked);
        }}
      />
    </ActionsContent>
  );
};

ToggledSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  initialState: PropTypes.bool,
  onConfirmAction: PropTypes.func.isRequired,
};